export function parseOddsToDecimal(input) {
  if (input == null) return null;
  const s = String(input).trim().toLowerCase();
  if (!s) return null;
  if (s === "evens" || s === "evs" || s === "even") return 2.0;

  if (s.includes("/")) {
    const [aRaw, bRaw] = s.split("/");
    const num = Number(String(aRaw).trim().replace(",", "."));
    const den = Number(String(bRaw).trim().replace(",", "."));
    if (!Number.isFinite(num) || !Number.isFinite(den) || den <= 0) return null;
    return +(1 + num / den).toFixed(4);
  }

  const dec = Number(s.replace(",", "."));
  if (!Number.isFinite(dec)) return null;
  return +dec.toFixed(4);
}

